import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { register, formatApiError } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("A jelszónak legalább 6 karakter hosszúnak kell lennie");
      return;
    }
    setSubmitting(true);
    try {
      await register(email, password, name);
      nav("/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-8 grid-bg">
      <form onSubmit={onSubmit} className="w-full max-w-sm bg-[#0A0A0A] border border-white/10 p-8" data-testid="register-form">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 bg-[#007AFF] flex items-center justify-center text-white font-display font-bold text-sm">
            T
          </div>
          <div className="font-display text-xl font-bold tracking-tight">TIPPADÓ</div>
        </div>

        <h2 className="font-display text-3xl font-bold mb-1 tracking-tight">Regisztráció</h2>
        <p className="text-sm text-zinc-400 mb-8">Hozz létre új fiókot</p>

        <div className="space-y-5">
          <div>
            <Label htmlFor="name" className="text-xs uppercase tracking-wider text-zinc-400">Név</Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="register-name-input"
              className="mt-1.5 bg-[#141414] border-white/10 focus-visible:ring-[#007AFF] focus-visible:ring-2"
              placeholder="Teljes név"
            />
          </div>
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-wider text-zinc-400">E-mail cím</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="register-email-input"
              className="mt-1.5 bg-[#141414] border-white/10 focus-visible:ring-[#007AFF] focus-visible:ring-2"
              placeholder="te@email.hu"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-wider text-zinc-400">Jelszó</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              data-testid="register-password-input"
              className="mt-1.5 bg-[#141414] border-white/10 focus-visible:ring-[#007AFF] focus-visible:ring-2"
              placeholder="Min. 6 karakter"
            />
          </div>

          {error && (
            <div data-testid="register-error" className="text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/30 px-3 py-2">
              {error}
            </div>
          )}

          <Button
            type="submit"
            disabled={submitting}
            data-testid="register-submit-btn"
            className="w-full bg-[#007AFF] hover:bg-[#3395FF] text-white font-medium tracking-tight h-11"
          >
            {submitting ? "Regisztráció..." : "Regisztráció"}
          </Button>
        </div>

        <div className="mt-6 text-sm text-zinc-400 text-center">
          Már van fiókod?{" "}
          <Link to="/login" data-testid="goto-login-link" className="text-[#007AFF] hover:underline">
            Bejelentkezés
          </Link>
        </div>
      </form>
    </div>
  );
}
